export const tabsStyle = {
  'display': 'flex',
  'flexDirection': 'column',
  '& > :first-child': {
    overflow: 'hidden',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  },
};

export const tabStyle = {
  flex: '1 0 auto',
};
